import axios from 'axios';
import { setMessage } from '../actions/setMessage';
import { ParseError } from '../functions/error-parse';
import { serverErrors } from '../functions/server-error';
import { map } from 'underscore';

function json(response) {
    return response.data;
}

export const baseQuery = async (
    { route, data = {}, transformUrl },
    { dispatch, getState }
) => {
    let options = {
        url:
            typeof transformUrl === 'function'
                ? transformUrl(route.url)
                : route.url,
        method: route.method,
    };
    if (route.method === 'post') {
        if (route.formData) {
            let formData = new FormData();
            for (let item in data) {
                if (data.hasOwnProperty(item)) {
                    if (
                        data === Object(data[item]) ||
                        Array.isArray(data[item])
                    ) {
                        map(data[item], (i, key) => {
                            formData.append(item + '[' + key + ']', i);
                        });
                    } else formData.append(item, data[item]);
                }
            }

            options = { ...options, data: formData };
        } else {
            options = { ...options, data: data };
        }
    } else options.url += data ? '/' + data : '';

    try {
        const response = await axios(options);
        const formatted = json(response);
        const data_response = formatted?.data_response;
        if (!formatted.success || !data_response?.success) {
            if (formatted?.msg || data_response?.msg) {
                dispatch(
                    setMessage(
                        ParseError(formatted?.msg || data_response?.msg),
                        'error'
                    )
                );
            } else {
                dispatch(setMessage('Неверные данные', 'error'));
            }
            return {
                error: 'requestError',
            };
        }
        return (
            !formatted.ignore && {
                data: formatted,
            }
        );
    } catch (error) {
        console.error('Request catch:', error);
        if (error.response) {
            if (serverErrors.hasOwnProperty(error.response.status)) {
                dispatch(
                    setMessage(serverErrors[error.response.status], 'error')
                );
            } else {
                dispatch(setMessage('Неопознанная ошибка', 'error'));
            }
        } else {
            dispatch(
                setMessage(
                    'Ошибочка вышла. Обновите и попробуйте снова.',
                    'error'
                )
            );
        }
        return {
            error: {
                status: error.response?.status,
                data: error.response?.data || error.message,
            },
        };
    }
};
